import { useEffect, useState } from "react";
import { Stack, Text } from "@mantine/core";
import { useLocation, useNavigate } from "react-router-dom";

import { useLocale } from "@/apps/@components";
import { logWallpaperEvent, logWallpaperPage } from "../wallpaperLog";
import { CampaignButton, WallpaperCarousel } from "../components";
import { WALLPAPERS } from "../wallpapers";
import { useWallpaperFlow } from "./WallpaperFlowContext";
import { getStoredFrom } from "../wallpaperParams";

export default function WallPaperStartPage() {
	const { t } = useLocale();
	const navigate = useNavigate();
	const { search } = useLocation();
	const { wallpaperId, update } = useWallpaperFlow();
	const { locale } = useLocale();

	const langSuffix = locale === "en" ? "?lang=en" : "";

	// 從流程狀態還原上次選到的那張（沒有就從第一張開始）
	const initialIndex = Math.max(
		0,
		WALLPAPERS.findIndex((w) => w.id === wallpaperId),
	);
	const [index, setIndex] = useState(initialIndex);

	const handleNext = () => {
		const selectedId = WALLPAPERS[index].id;

		logWallpaperEvent({
			category: "cta",
			path: `/wallpaper/select${langSuffix}`,
			action: "select",
			event: "cta_pattern_select",
			value: String(selectedId),
		});

		update({ wallpaperId: selectedId });
		navigate({ pathname: "/wallpaper/text-setting", search });
	};

	useEffect(() => {
		logWallpaperPage({
			path: `/wallpaper/select${langSuffix}`,
			from: getStoredFrom(),
		});
	}, []);

	return (
		<Stack
			gap="8vw"
			align="center"
			w="100%"
			pt="1.5vw"
			pb="11vw"
			bg="#FFFCF6"
			style={{ overflowX: "hidden" }}
		>
			<Text
				size={locale === "en" ? "4vw" : "4.5vw"}
				c="#433931"
				fw={500}
				lh="normal"
				ta="center"
				style={{
					flexShrink: 0,
					letterSpacing: locale === "en" ? "-0.03em" : "0.1em",
				}}
			>
				{t("start.title")}
			</Text>

			<WallpaperCarousel initialIndex={initialIndex} onSelect={setIndex} />

			<CampaignButton
				w="50.8vw"
				style={{
					flexShrink: 0,
					letterSpacing: locale === "en" ? "0.06em" : "0.2em",
				}}
				fz={locale === "en" ? "3.3vw" : "4vw"}
				onClick={handleNext}
			>
				{t("start.btn")}
			</CampaignButton>
		</Stack>
	);
}
